/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_dashboard': {
    width: 100.787,
    height: 100.787,
    viewBox: '0 0 100.787 100.787',
    data: '<path pid="0" d="M99.288 94.894H3v-90.5a1.5 1.5 0 10-3 0v92a1.5 1.5 0 001.5 1.5h97.787a1.5 1.5 0 00.001-3z"/><path pid="1" d="M68.061 52.727c-13.332 22.667-19.891.453-22-6-3.584-10.961-20.395-41.783-40.667-9.666v54.667h93c.001-.001-11.333-77.334-30.333-39.001z"/>'
  }
})
